import Index from '@tunnel-components/@pages/fogetPassword/container'

/**
 * @export Container
 */

export default Index



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/fogetPassword/index.ts